import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSubSection, setSubPage } from '../../../../../redux/actions';
import VideoPlayer from '../../../../Shared/VideoPlayer/VideoPlayer';
import './Outro.css';
import BtnTopMenu from '../SceneUI/BtnTopMenu/BtnTopMenu';
import { SUB_PAGE } from '../../../../../constants';
import { SUB_SECTION_VIDEO } from '../../../../../content';
import BackButton from '../../../../Shared/BackButton/BackButton';

// note - buttons are similar to ones in sceneUI - maybe create whole menu as component

class Outro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
    };

    this.handleClickMovie = this.handleClickMovie.bind(this);
    this.handleClickDoc = this.handleClickDoc.bind(this);
    this.handleClickNames = this.handleClickNames.bind(this);
    this.handleClickInfo = this.handleClickInfo.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
  }

  // -------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------

  componentWillMount() {
    this.setState({
      complete: false,
    });
  }

  // -------------------------------------------------------
  // Buttons
  // -------------------------------------------------------

  handleClickMovie() {}

  handleClickDoc() {}

  handleClickNames() {
    this.props.setSubSection('');
    this.props.setSubPage(SUB_PAGE.MEMORIAL);
  }

  handleClickInfo() {
    this.props.setSubSection('');
    this.props.setSubPage(SUB_PAGE.INFO);
  }

  handleClick() {
    this.props.setSubSection('');
  }

  handleEnd() {
    this.setState({
      complete: true,
    });
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    return (
      <div id="outro-section">
        <VideoPlayer
          source={SUB_SECTION_VIDEO.OUTRO}
          onEnded={this.handleEnd}
        />
        <div
          id="outro-end-menu"
          className={this.state.complete ? 'active' : ''}
        >
          <div id="outro-end-menu-btns">
            <BtnTopMenu id={0} onClick={this.handleClickMovie} />
            <BtnTopMenu id={1} onClick={this.handleClickDoc} />
            <BtnTopMenu id={2} onClick={this.handleClickNames} />
            <BtnTopMenu id={3} onClick={this.handleClickInfo} />
          </div>
        </div>
        <BackButton onClick={this.handleClick} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setSubSection: sectionId => dispatch(setSubSection(sectionId)),
  setSubPage: pageId => dispatch(setSubPage(pageId)),
});

export default connect(null, mapDispatchToProps)(Outro);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/Outro/Outro.js